import React from 'react';
import { AdminH1 } from '../../components/AdminH1';
import { PopUpFormListTable } from '../../components/PopUpFormListTable';

export const PopUpFormPage = () => {
  return (
    <div className="space-y-5">
      <AdminH1>팝업 문의 요청 관리</AdminH1>
      <PopUpFormListTable />
    </div>
  );
};
